// import en from './en';
import ko from './ko';

import LocalizedStrings from 'react-localization';
let strings = new LocalizedStrings({ /*en, */ko });
strings.setLanguage('ko');

export default strings;